"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./BaseCard.css");
require("./BaseCard.desktop.css");
var BaseCardProps_1 = require("./BaseCardProps");
var BaseCardStylesMaps_1 = require("./BaseCardStylesMaps");
var ContainerLoader_1 = require("../../atoms/ContainerLoader/ContainerLoader");
var ImageFileTypes = ['png', 'jpg', 'svg', 'gif', 'jpeg'];
var BaseCard = /** @class */ (function (_super) {
    __extends(BaseCard, _super);
    function BaseCard(props) {
        var _this = _super.call(this, props) || this;
        _this.initialize();
        _this.bindAll();
        return _this;
    }
    BaseCard.prototype.bindAll = function () {
        this.getCustomClassNames = this.getCustomClassNames.bind(this);
    };
    BaseCard.prototype.getCustomClassNames = function (props) {
        if (props.options && props.options.className) {
            return props.options.className;
        }
        return '';
    };
    BaseCard.prototype.getBaseCardContent = function () {
        if (this.props.options.isLoading) {
            return (React.createElement(ContainerLoader_1.default, null));
        }
        else {
            return (this.props.children);
        }
    };
    BaseCard.prototype.render = function () {
        var classes = [
            styles.card,
            this.getType(this.props.options),
            this.getCustomClassNames(this.props),
        ];
        return (React.createElement("div", { "data-test-id": this.props.testId, className: classes.join(' '), style: this.style, tabIndex: this.props.options.tabIndex, "aria-label": this.props.options.accessibility }, this.getBaseCardContent()));
    };
    BaseCard.prototype.getType = function (options) {
        return BaseCardStylesMaps_1.typesMap[options.type];
    };
    BaseCard.prototype.initialize = function () {
        var str = this.props.data.background;
        if (str !== '' && str !== undefined) {
            if (ImageFileTypes.some(function (v) { return str.indexOf(v) >= 0; })) {
                this.style = {
                    background: "url(" + this.props.data.background + ") center center/cover no-repeat #FFFFFF",
                };
            }
            else {
                this.style = {
                    background: "" + this.props.data.background,
                };
            }
        }
    };
    BaseCard.defaultProps = {
        options: {
            isLoading: false,
            type: BaseCardProps_1.BaseCardType.DEFAULT,
        },
    };
    return BaseCard;
}(React.Component));
exports.default = BaseCard;
//# sourceMappingURL=BaseCard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/BaseCard/BaseCard.js
// module id = 1301
// module chunks = 8